import {convertDirectionToXY, Directions, REACH} from "./direction";
import {Position} from "./game_element_schema";

export function withinReach(i: Position, c: { x: number, y: number, direction: Directions }): boolean {
    if(!withinReachingDistance(i, c))
        return false

    if (! inSight(c, i))
        return false
    return true
}

export function withinReachingDistance(i: Position, c: Position): boolean {
    return distance(c, i) <= REACH
}

function inSight(c: { x: number; y: number; direction: Directions }, i: Position) {
    return Math.abs(ingredientAngleForCook(c, i)) <= Math.PI * 5 / 12; // 75° half-angle (150° total cone)
}

export function distance(c: { x: number; y: number }, i: { x: number; y: number }): number {
    return Math.sqrt( (i.x - c.x)**2+(i.y - c.y)**2)
}

export function angle({x, y}: Position) {
    return Math.atan2(y, x);
}

export function ingredientAngleForCook(c: { x: number; y: number; direction: Directions }, i: { x: number; y: number }): number {
    const ingredientAngle = Math.atan2(i.y - c.y, i.x - c.x)
    const cookDirectionAngle = angle(convertDirectionToXY(c.direction))
    const diff = ingredientAngle - cookDirectionAngle;
    return Math.atan2(Math.sin(diff), Math.cos(diff));
}

